<template>
    <div class="flex items-center justify-between mt-4" v-if="pagination && pagination.last_page > 1">
        <div class="text-sm text-gray-700">
            Showing <span class="font-medium">{{ pagination.from || 0 }}</span> to 
            <span class="font-medium">{{ pagination.to || 0 }}</span> of 
            <span class="font-medium">{{ pagination.total || 0 }}</span> results
        </div>
        <div class="flex space-x-1">
            <button 
                @click="$emit('page-changed', pagination.current_page - 1)"
                :disabled="pagination.current_page === 1"
                class="px-3 py-1 border rounded"
                :class="{'opacity-50 cursor-not-allowed': pagination.current_page === 1}"
            >
                Previous
            </button>
            <button 
                v-for="page in visiblePages" 
                :key="page"
                @click="$emit('page-changed', page)"
                class="px-3 py-1 border rounded"
                :class="{'bg-blue-500 text-white': pagination.current_page === page}"
            >
                {{ page }}
            </button>
            <button 
                @click="$emit('page-changed', pagination.current_page + 1)"
                :disabled="pagination.current_page === pagination.last_page"
                class="px-3 py-1 border rounded"
                :class="{'opacity-50 cursor-not-allowed': pagination.current_page === pagination.last_page}"
            >
                Next
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReoptPagination',
    props: {
        pagination: {
            type: Object,
            required: true,
            default: () => ({
                current_page: 1,
                last_page: 1,
                from: 0,
                to: 0,
                total: 0
            })
        },
        maxVisiblePages: {
            type: Number,
            default: 5
        }
    },
    computed: {
        visiblePages() {
            const range = [];
            const half = Math.floor(this.maxVisiblePages / 2);
            let start = Math.max(1, this.pagination.current_page - half);
            let end = Math.min(this.pagination.last_page, start + this.maxVisiblePages - 1);
            
            if (end - start + 1 < this.maxVisiblePages) {
                start = Math.max(1, end - this.maxVisiblePages + 1);
            }
            
            for (let i = start; i <= end; i++) {
                range.push(i);
            }
            
            return range;
        }
    }
};
</script>
